
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DssButtonModule, DssCardModule, DssCardOptionModule, DssCheckboxModule, DssRadioGroupModule } from '@dss/components';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CardCbioComponent } from './cardCbio/card-cbio.component';
import { OfertasService } from './services/ofertas/ofertas.service';


// import { encryptionConfig } from './config/encryption.config';

registerLocaleData(ptBr, 'pt-BR');

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    DssButtonModule,
    DssCardModule,
    DssCardOptionModule,
    DssCheckboxModule,
    DssRadioGroupModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }),
    AppComponent,
    CardCbioComponent,
  ],
  providers: [
    OfertasService,
    ...provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json' }),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
  ngDoBootstrap() {}
 }
